import React, { useEffect, useState } from 'react';
import UserCard from './UserCard';
import './users.css';

const Users = ({ dataUsers, socket }) => {
    const [filteredUsers, setFilteredUsers] = useState([]); // Estado para los usuarios filtrados
    const [searchQuery, setSearchQuery] = useState(''); // Estado para la búsqueda

    const handleSearch = (e) => {
        const query = e.target.value.toLowerCase(); // Convertir a minúsculas para búsqueda insensible a mayúsculas
        setSearchQuery(query);

        if (query === '') {
            setFilteredUsers(dataUsers); // Si no hay búsqueda, mostrar todos los usuarios
        } else {
            const filtered = dataUsers.filter(user =>
                user.email.toLowerCase().includes(query)
            );
            setFilteredUsers(filtered); // Actualizar usuarios filtrados
        }
    };
    useEffect(()=>{
        setFilteredUsers(dataUsers)
    },[dataUsers])

    return (
        <div className="users-container">
            <div className="search-bar">
                <input
                    type="text"
                    placeholder="Buscar por correo"
                    value={searchQuery}
                    onChange={handleSearch}
                    className="search-input"
                />
            </div>
            <div className="users">
                {filteredUsers.length > 0 ? (
                    filteredUsers.map((user, index) => (
                        <UserCard key={index} user={user} socket={socket}/>
                    ))
                ) : (
                    <p>No se encontraron usuarios con ese correo.</p>
                )}
            </div>
        </div>
    );
};

export default Users;
